import './Venue.scss';

const TaxiIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
  </svg>
);

const Venue = () => {
  return (
    <section className="venue">
      <div className="venue__content">
        <div className="venue__left">
          <img
            className="venue__photo"
            src="/place_new.png"
            alt="Место проведения"
            onError={(e) => {
              e.target.src = '/placeholder-venue.jpg';
            }}
          />

          <div className="venue__map">
            <iframe
              src="https://yandex.ru/map-widget/v1/?ll=65.447145%2C57.234184&z=14&l=map&pt=65.447145,57.234184,pm2rdm"
              allowFullScreen={true}
              title="Карта места проведения"
            />
          </div>
        </div>

        <div className="venue__info">
          <h2 className="venue__title">Место</h2>
          <h3 className="venue__name">Будем ждать вас по <br/> адресу:</h3>
          <h3 className="venue__name__short">Будем ждать вас по адресу:</h3>
          <p className="venue__address">
            г. Тюмень, Салаирский тракт 10 километр, ст1 <br/> “Хранитель сказок”
          </p>
          <p className="venue__address__short">
            г. Тюмень, <br/> Салаирский тракт 10 километр, <br/> ст1 “Хранитель сказок”
          </p>
          <a
             className="venue__button"
             href="https://3.redirect.appmetrica.yandex.com/route?end-lat=57.234184&end-lon=65.447145&level=50&appmetrica_tracking_id=1178268795219780156"
             target="_blank"
             rel="noopener noreferrer"
          >
            Заказать такси
          </a>
        </div>

        <a
           className="venue__button__short"
           href="https://3.redirect.appmetrica.yandex.com/route?end-lat=57.234184&end-lon=65.447145&level=50&appmetrica_tracking_id=1178268795219780156"
           target="_blank"
           rel="noopener noreferrer"
        >
          Заказать такси
        </a>
      </div>
    </section>
  );
};

export default Venue;
